import { useEffect, useState } from "react";
import "../../../newComponents/listings/top-listing-headers/top-listing-headers.css";
import SearchFilterInput from "../../../newComponents/form-fields/search-filter-input";
import SimpleButton from "../../../newComponents/buttons/Simple-button";
import H2 from "../../../newComponents/typography/H2";

// Interface updated to remove sorting props, mirroring UnitTopHeader minus sorting
interface PaymentAccountsTopHeaderProps {
  className?: string;
  PageHeading?: string;
  Count?: number;
  ButtonName?: string;
  MobileButtonName?: string;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onClick?: () => void;
  handleFilterChange: (filter: string) => void;
  aggregateValuesFilters?: Record<string, number>;
  isAddDisabled?: boolean;
  addDisabledMessage?: string;
}

export default function PaymentAccountsTopHeader({
  className = "",
  PageHeading,
  Count,
  ButtonName,
  MobileButtonName,
  searchTerm,
  setSearchTerm,
  onClick,
  handleFilterChange,
  aggregateValuesFilters,
  isAddDisabled = false,
  addDisabledMessage,
}: PaymentAccountsTopHeaderProps) {
  const [filterOptions, setFilterOptions] = useState<{ title: string; count: number }[]>([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [shouldUpdateCounts, setShouldUpdateCounts] = useState(true);

  // Dynamically populate filter options, mirroring UnitTopHeader
  useEffect(() => {
    if (aggregateValuesFilters && Count !== undefined && shouldUpdateCounts) {
      const options = Object.entries(aggregateValuesFilters).map(([title, count]) => ({
        title,
        count,
      }));
      const totalCount = options.reduce((acc, curr) => acc + curr.count, 0);
      setFilterOptions([{ title: "All", count: totalCount }, ...options]);
    }
  }, [aggregateValuesFilters, Count, shouldUpdateCounts]);

  // Update counts on search term change
  useEffect(() => {
    setShouldUpdateCounts(true);
  }, [searchTerm]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterTabChange = (title: string) => {
    setActiveFilter(title);
    setShouldUpdateCounts(false);
    handleFilterChange(title);
  };

  return (
    <>
  
    <div className={`top-listing-header payment-accounts-header ${className}`}>
      <div className="top-listing-header-main">
        <div className="top-listing-header-left">
          <H2 text={PageHeading || ""} />
        </div>

        <div className="top-listing-header-right">
          <div className="payment-header-actions">
            <SearchFilterInput
              placeholder="Search by Account Name"
              searchTerm={searchTerm}
              handleSearch={handleSearch}
            />

            {ButtonName && (
              <span title={isAddDisabled ? addDisabledMessage : undefined}>
                <SimpleButton
                  className="top-listing-header-button-desktop"
                  label={ButtonName}
                  onClick={onClick}
                  isDisabled={isAddDisabled}
                />
              </span>
            )}
            {(MobileButtonName || ButtonName) && (
              <span title={isAddDisabled ? addDisabledMessage : undefined}>
                <SimpleButton
                  className="top-listing-header-button-mobile"
                  label={MobileButtonName || ButtonName}
                  onClick={onClick}
                  isDisabled={isAddDisabled}
                />
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
</>
  );
}